// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2siQR","tab":"Tabs_tab__3R6Z1","tabActive":"Tabs_tabActive__2rouG"};